var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCommonIconWalkingColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFB74D",
    d: "M19.072 15.016a.966.966 0 01-.297-.048l-3.447-1.578a.94.94 0 01-.593-.594L12.5 7.5c-.163-.49.66-.806 1.151-.968a.938.938 0 011.185.596l1.531 4.632 3.002 1.428a.938.938 0 01-.298 1.828z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#606FC4",
    d: "M14.242 11.629l1.786-.893-1.193-3.609a.937.937 0 00-1.184-.595c-.492.162-1.314.477-1.151.968l1.742 4.129z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB74D",
    d: "M14.063 0a2.188 2.188 0 11-.001 4.375A2.188 2.188 0 0114.063 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B2AEAD",
    d: "M5.625 25a1.25 1.25 0 01-.96-2.051l2.961-3.552 1.802-6.006a1.249 1.249 0 011.556-.838c.662.198 1.714 1.16 1.516 1.822l-2.553 5.984c-.048.16-.129.312-.237.442L6.585 24.55a1.252 1.252 0 01-.96.449z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7E8CCF",
    d: "M11.253 16.563a2.186 2.186 0 01-2.154-2.579L10.66 7.42a2.183 2.183 0 012.543-1.76 2.186 2.186 0 011.76 2.543l-1.562 6.561a2.188 2.188 0 01-2.15 1.797z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB74D",
    d: "M5.948 15.625a.94.94 0 01-.929-1.08l.988-4.706a.942.942 0 01.357-.603l4.257-3.262c.629-.349 1.254-.349 2.26-.349.517 0-.595 2.185-1.006 2.5l-4.071 2.37-.93 4.334a.94.94 0 01-.927.796z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2CCC9",
    d: "M15.811 19.209l-.041-.056-2.458-4.062c.036-.105.07-.213.09-.326l.037-.156-4.238-1.059-.103.434a2.178 2.178 0 00.827 2.12l3.825 4.521 2.085 3.818a1.247 1.247 0 001.733.347 1.25 1.25 0 00.347-1.733l-2.104-3.848z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7E8CCF",
    d: "M12.881 5.625c-1.006 0-1.631 0-2.26.35L7.929 8.036l1.303 1.627 2.643-1.538c.411-.315 1.524-2.5 1.006-2.5z"
  }))));
}

export default SvgCommonIconWalkingColor;